import { c as _c } from "react/compiler-runtime";
import { FaceLandmarker, FilesetResolver } from '@mediapipe/tasks-vision';
import type React from 'react';
import { createContext, useContext, useEffect, useState } from 'react';

// WASM runtime files (vision_wasm_internal.js/.wasm) must be served at /model/.
// Copy from node_modules/@mediapipe/tasks-vision/wasm/ into
// frontend/packages/idv2/.storybook/public/model/ (done once, committed to the repo).
// The face_landmarker.task model file must also be at /model/face_landmarker.task.
// For production Next.js deployments, serve the same files from the /public/model/ dir.
const MEDIAPIPE_WASM_PATH = '/model';
const MODEL_URL = '/model/face_landmarker.task';
type FaceModelLoaderType = {
  isSelfieRequired: boolean;
};
const useFaceModelLoader = t0 => {
  const $ = _c(3);
  const {
    isSelfieRequired
  } = t0;
  const [landmarker, setLandmarker] = useState(null);
  let t1;
  let t2;
  if ($[0] !== isSelfieRequired) {
    t1 = () => {
      if (!isSelfieRequired) {
        return;
      }
      const loadModel = async () => {
        ;
        try {
          const vision = await FilesetResolver.forVisionTasks(MEDIAPIPE_WASM_PATH);
          const instance = await FaceLandmarker.createFromOptions(vision, {
            baseOptions: {
              modelAssetPath: MODEL_URL,
              delegate: "CPU"
            },
            runningMode: "IMAGE",
            numFaces: 1,
            outputFacialTransformationMatrixes: true
          });
          setLandmarker(instance);
        } catch (t3) {
          const err = t3;
          console.error(`Error loading the face model: ${err}`);
        }
      };
      loadModel();
    };
    t2 = [isSelfieRequired];
    $[0] = isSelfieRequired;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return landmarker;
};
type FaceModelContextValue = FaceLandmarker | null;
const FaceModelContext = createContext<FaceModelContextValue>(null);
type FaceModelProviderProps = {
  isSelfieRequired: boolean;
  children: React.ReactNode;
};
const FaceModelProvider = t0 => {
  const $ = _c(5);
  const {
    isSelfieRequired,
    children
  } = t0;
  let t1;
  if ($[0] !== isSelfieRequired) {
    t1 = {
      isSelfieRequired
    };
    $[0] = isSelfieRequired;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const landmarker = useFaceModelLoader(t1);
  let t2;
  if ($[2] !== children || $[3] !== landmarker) {
    t2 = <FaceModelContext.Provider value={landmarker}>{children}</FaceModelContext.Provider>;
    $[2] = children;
    $[3] = landmarker;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
const useFaceModel = () => {
  return useContext(FaceModelContext);
};
export { FaceModelProvider, useFaceModel };